/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\AttribuedCar\AttribuedCarTab\AttribuedCarTab.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 16th 2024 10:04:08 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useState } from "react";
import AttribuedCarService from "Services/AttribuedCar/AttribuedCarService";
import { TablePaper } from "Content/Table/TablePaper";
import { AttribuedCarType } from "Types/AttribuedCar.type";
import AttribuedCarRow from "../AttribuedCarRow/AttribuedCarRow";

type AttribuedCarTabProps = {
    offerID: string,
};

export default function AttribuedCarTab(props: AttribuedCarTabProps) {
    const [attribuedCar, setAttribuedCar] = useState<AttribuedCarType[]>([]);
    const offerKeysOffer = ["File", "RegNb", "VIN", "OrderNb", "MEC", "DateDelivery", "DateReport", "DateEndContract", "EndMileage"];

    useEffect(() => {
        AttribuedCarService.getAttribuedCar(props.offerID).then((result) => {
            if (result.data)
                setAttribuedCar(result.data);
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    const offerValues = useMemo(() => {
        return attribuedCar.map(x => <AttribuedCarRow key={Math.random()} data={x}/>);
    }, [attribuedCar]);

    return (
        <TablePaper items={offerValues} headerList={offerKeysOffer} isCollapsable />
    );
};
